import React from 'react';
import { Link } from 'react-router-dom';
import {
  HelpCircle,
  FileCheck,
  CreditCard,
  MessageCircle
} from 'lucide-react';

/**
 * Help Links Panel for sidebar
 * Displays helpful navigation links
 */
const HelpLinksPanel = ({ className = '' }) => {
  const links = [
    { label: 'Help Center', icon: HelpCircle, href: '#' },
    { label: 'Browse Direct Contracts', icon: FileCheck, href: '/proposals' },
    { label: 'View Billing', icon: CreditCard, href: '/settings/billing' },
    { label: 'Contact Support', icon: MessageCircle, href: '#' },
  ];

  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-3 ${className}`}>
      <ul className="space-y-1">
        {links.map((link) => (
          <li key={link.label}>
            {link.href.startsWith('#') ? (
              <a
                href={link.href}
                className="flex items-center gap-2 px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded transition-colors"
              >
                <link.icon className="w-4 h-4 text-gray-400" />
                {link.label}
              </a>
            ) : (
              <Link
                to={link.href}
                className="flex items-center gap-2 px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded transition-colors"
              >
                <link.icon className="w-4 h-4 text-gray-400" />
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HelpLinksPanel;
